function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_3920",
  transform: "translate(-246 1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_821",
  d: "M250.75 0h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_822",
  d: "M264.25 0h-10.5a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h10.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_823",
  d: "M250.75 6.75h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_824",
  d: "M264.25 6.75h-10.5a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h10.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_825",
  d: "M250.75 13.5h-3a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h3a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_826",
  d: "M264.25 13.5h-10.5a.75.75 0 0 0-.75.75v3a.75.75 0 0 0 .75.75h10.5a.75.75 0 0 0 .75-.75v-3a.75.75 0 0 0-.75-.75z"
}));
var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2315",
  fill: "none",
  d: "M0 0H20V20H0z"
});
var SvgHoldersList = function SvgHoldersList(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_259_1",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHoldersList, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/holders-list.2c30b854.svg";
export { ForwardRef as ReactComponent };